import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useCallback } from "react";
import { Image, Link } from "@sitecore-jss/sitecore-jss-react"; //Demonstrates usage of an Image content field within JSS.

import { Button } from "react-bootstrap";
import { SitecoreLink } from "../link/Link";

var JoinRewardsPromo = function JoinRewardsPromo(props) {
  var authenticationState = props.authenticationState,
      fields = props.fields;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModule = _useState2[0],
      setShowModule = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      parentInnerHeight = _useState4[0],
      setParentHeight = _useState4[1];

  console.log("JoinRewardsPromo fields", fields);
  if (!fields || Object.keys(fields).length === 0) return null;
  var BackgroundImage = fields.BackgroundImage,
      LearnMoreLink = fields.LearnMoreLink,
      LogoImage = fields.LogoImage,
      Header = fields.Header,
      SignInLink = fields.SignInLink;
  useEffect(function () {
    if (authenticationState) {
      var authenticationStateToLower = authenticationState.toLowerCase(); // Module should only show if user is unauthenticated

      if (authenticationStateToLower !== "unauthenticated") {
        setShowModule(false);
        return;
      }

      setShowModule(true);
    }
  }, [authenticationState]);
  var measuredRef = useCallback(function (node) {
    if (node !== null) {
      setParentHeight(node.getBoundingClientRect().height * 1.3);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showModule &&
  /*#__PURE__*/
  // we add the parentHeight to the style to ensure the parent container is tall enough to show the entire module
  // this is needed because the module is absolutely positioned
  React.createElement("div", {
    className: "cb-join-rewards-promo",
    style: {
      height: parentInnerHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-join-rewards-promo__background"
  }, /*#__PURE__*/React.createElement(Image, {
    field: BackgroundImage,
    className: "cb-join-rewards-promo__background--image"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-join-rewards-promo__header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cb-join-rewards-promo__header--tag"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cb-join-rewards-promo__header--tag-text"
  }, "New")), LearnMoreLink && LearnMoreLink.value !== "" && /*#__PURE__*/React.createElement(Link, {
    field: LearnMoreLink,
    className: "cb-join-rewards-promo__header--link"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-join-rewards-promo__content",
    ref: measuredRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-join-rewards-promo__logo"
  }, /*#__PURE__*/React.createElement(Image, {
    field: LogoImage,
    className: "cb-join-rewards-promo__logo--image"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-join-rewards-promo__copy"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cb-join-rewards-promo__copy--title"
  }, Header.value)), SignInLink && /*#__PURE__*/React.createElement(SitecoreLink, {
    field: SignInLink,
    className: "cb-join-rewards-promo__cta"
  }))));
};

export default JoinRewardsPromo;